import React from 'react';

const ListBullet = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none"
  },
  /* @__PURE__ */ React.createElement("path", { d: "M14 14H0V7L7 0L14 7V14Z", fill: "url(#paint0_linear_21677_313775)" }),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement(
    "linearGradient",
    {
      id: "paint0_linear_21677_313775",
      x1: "0",
      y1: "7",
      x2: "14",
      y2: "7",
      gradientUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ React.createElement("stop", { stopColor: "#EAA831" }),
    /* @__PURE__ */ React.createElement("stop", { offset: "0.275", stopColor: "#CD942C" }),
    /* @__PURE__ */ React.createElement("stop", { offset: "0.445", stopColor: "#BD8828" }),
    /* @__PURE__ */ React.createElement("stop", { offset: "1", stopColor: "#845F1C" })
  ))
);
ListBullet.displayName = "Icons.ListBullet";

export { ListBullet };
//# sourceMappingURL=ListBullet.js.map
